import { render, staticRenderFns } from "./OwnStrategy.vue?vue&type=template&id=07977b84&scoped=true"
import script from "./OwnStrategy.vue?vue&type=script&lang=js"
export * from "./OwnStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07977b84",
  null
  
)

export default component.exports